import  * as React from 'react'
// Bilder und PDFs
import { StaticImage } from 'gatsby-plugin-image'; // Bilder

// Translation
import {useI18next} from 'gatsby-plugin-react-i18next'
import { graphql } from 'gatsby';
//components
import Layout from '../../components/layout/layout'
import { Seo } from '../../components/seo';

//const: muss definiert werden unter export default Biobasiert
//const: data eingefügt für PDFS hochladen
const Zertifizierung2  = ({data}) => {
    const {t} = useI18next();
    return (
        <Layout pageTitle={t('title')} subTitle={t('subtitle')}>
          {/* Block mit weissem hintergrund 
          <div className='row'>

            <div className='col-12'>
              <div className='container'>
                <BoxInfo description={t('text')} />
              </div>
            </div>
          </div>
        */}
          <div className='row'>
            {/* 1 oder mehr Blöcke am Anfang: Titel und Text / ggf später ein Bild */}
            <div className='col-12'>
              <div className='container'>
                {/* 1. Überschrift */}
                <h1 align="center"> {t('title1')} </h1>
                <p> {t('text11')} </p>
                <p> {t('text12')} </p>
                {/* 2. Iso 9001 */}
                <h2 align="center"> {t('title2')} </h2>
                <p> {t('text21')} </p>
                <p>  
                  <a href={data.pdfiso9001.publicURL} download>{t('text22')} </a>

                </p>  
                {/* 3. Recyclass */} 
                <h2 align="center"> {t('title3')} </h2>
                <p> {t('text31')} </p>
                <p> {t('text32')} </p>
                
                <p>  
                  <a href={data.pdfrecyclass.publicURL} download>{t('text33')} </a>

                </p>  
              
                
            
                {/*<p>{t('bildtext1')}</p>              : ggf ein Bild einfügen / passt hier aber nicht
                <StaticImage alt="ein bil d" src="../images/CAD-Zeichnungen-RK.jpg"/> */}
              </div>
            </div>
          </div>
        </Layout>

    );
};

export default Zertifizierung2

// Fuer Search engine  optimizationjj
export const Head = () =>( <Seo title="Zertifizierung" keywords="Zertifizierung Iso 9001" /> )

// Für Mehrsprachigkeit, graphql muss am anfang import werden!
export const query = graphql`
query ($language: String!) 
  {
    pdfrecyclass: file(relativePath: {eq: "Linotech-Recyclass-Recycled-Plastics-Traceability-Certific.pdf"}) 
      {
          publicURL
          name
      }
    pdfiso9001: file(relativePath: {eq: "Linotech-Zertifikat-Iso-9001-241113.pdf"}) 
      {
          publicURL
          name
      }

    locales: allLocale
     (
       filter: { ns: { in: ["zertifizierung2"] }, language: { eq: $language } }
     ) 
      {
        edges 
        {
          node 
          {
            ns
            data
            language
          }
        }
      }
  }
`;